import styled from "styled-components";

export const StyledArchiveCard = styled.div`
  display: grid;
  grid-template-columns: 5fr 64px;
  
  .item {
    &.deleted {
      opacity: .4;
    }
    background: rgba(255, 255, 255, 0.5);
    border: 1px solid var(--bllink-blue);
    box-shadow: 0px 3px 34px rgba(89, 102, 137, 0.05);
    border-radius: 11px;
    padding: 10px 32px;
    display: grid;
    grid-template-columns: repeat(5, 1fr) 32px;
    text-align: center;
    align-items: center;
    justify-items: center;
    color: rgba(55, 54, 71, 0.7);

    .download {
      cursor: pointer;
      margin: 0;
      padding: 0;
      border: none;
      background: transparent;
    }
  }
  
  .item-actions {
    display: flex;
    justify-content: center;

    .label {
      box-shadow: -2px 2px 8px 0px rgb(34 60 80 / 20%);
    }
  }
`
